enum ParticipantStatus {
  YES = "yes",
  NO = "no",
  MAYBE = "maybe",
  NOREPLY = "noreply",
}

export default ParticipantStatus;
